<script setup lang="ts">
// Section heading inside landing mocks, mirroring the real page section titles
// (SocialLinks/GamesDisplay/...): the page font in uppercase with 0.1em
// tracking at 70% text colour, between two separator lines in the page accent.
// `compact` is the small neutral version used by the miniature HeroPreview.
withDefaults(defineProps<{
  label: string
  /** Optional count after the title (friends section) */
  count?: number
  compact?: boolean
}>(), { count: undefined, compact: false })
</script>

<template>
  <div
    v-if="compact"
    class="flex items-center gap-2.5"
  >
    <div class="h-px flex-1 bg-(--mock-track)" />
    <span class="shrink-0 text-[9px] font-medium uppercase tracking-widest text-(--mock-text-dim)">{{ label }}</span>
    <div class="h-px flex-1 bg-(--mock-track)" />
  </div>
  <div
    v-else
    class="flex items-center gap-3"
  >
    <div class="h-px flex-1 bg-[rgba(var(--mock-accent-rgb),0.3)]" />
    <h3 class="flex shrink-0 items-baseline gap-1.5 text-[13px] uppercase tracking-widest text-(--mock-text)">
      {{ label }}
      <span
        v-if="count !== undefined"
        class="text-[11px] text-(--mock-text-dim)"
      >{{ count }}</span>
    </h3>
    <div class="h-px flex-1 bg-[rgba(var(--mock-accent-rgb),0.3)]" />
  </div>
</template>
